// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loader__loader__3eqKX","load3":"Loader__load3__2Ufyg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Loader/Loader.css
// module id = 280
// module chunks = 0